// SPDX-License-Identifier: AGPL-3.0-or-later

import RuntimeConfig from '@app/features/app/state/RuntimeConfig';
import {snapMediaProxyImageSize} from '@app/features/messaging/utils/MediaProxyUtils';
import {buildMediaUrl, parseAvatarHash} from '@app/features/user/utils/AvatarMediaUtils';
import type {MediaProxyImageSize} from '@fluxer/constants/src/MediaProxyImageSizes';

// The card image is a branding asset like a cosmetic's (owner cosmetic-username_card-<length>), uploaded at 96-480 px.
const MIN_SIZE: MediaProxyImageSize = 128;
const MAX_SIZE: MediaProxyImageSize = 480;

// An animated image plays only when asked: the shop grid asks for its still frame.
export function usernameCardImageUrl(length: 1 | 2 | 3, asset: string, cssSize: number, animated: boolean): string {
	const endpoint = RuntimeConfig.mediaEndpoint;
	if (!endpoint) return '';
	const {animated: isAnimated, hash} = parseAvatarHash(asset);
	const play = isAnimated && animated;
	const snapped = snapMediaProxyImageSize(cssSize);
	return buildMediaUrl({
		endpoint,
		path: 'branding',
		id: `cosmetic-username_card-${length}`,
		hash: play ? asset : hash,
		size: snapped < MIN_SIZE ? MIN_SIZE : snapped > MAX_SIZE ? MAX_SIZE : snapped,
		animated: play,
	});
}
